import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { ProjectCard, Project } from '../components/ProjectCard';
import { ArrowLeft, Plus, Filter, List, LayoutGrid } from 'lucide-react';
// Mock Data
const projects: Project[] = [{
  id: '1',
  name: 'Nike Summer Campaign',
  brand: {
    name: 'Nike'
  },
  creator: {
    name: 'Sarah Klein',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&auto=format&fit=crop&q=60'
  },
  deadline: '2024-06-15',
  status: 'active',
  budget: 5000
}, {
  id: '2',
  name: 'Adidas Fitness Series',
  brand: {
    name: 'Adidas'
  },
  creator: {
    name: 'Lisa Schmidt',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&auto=format&fit=crop&q=60'
  },
  deadline: '2024-07-01',
  status: 'planning',
  budget: 3000
}, {
  id: '3',
  name: 'Red Bull Event Coverage',
  brand: {
    name: 'Red Bull'
  },
  creator: {
    name: 'Tom Weber',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&auto=format&fit=crop&q=60'
  },
  deadline: '2024-06-20',
  status: 'active',
  budget: 8000
}, {
  id: '4',
  name: 'Samsung Tech Review',
  brand: {
    name: 'Samsung'
  },
  creator: {
    name: 'Felix Meyer',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&auto=format&fit=crop&q=60'
  },
  deadline: '2024-06-25',
  status: 'active',
  budget: 4500
}, {
  id: '5',
  name: 'Nike Sneaker Launch',
  brand: {
    name: 'Nike'
  },
  creator: {
    name: 'Emma Wilson',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&auto=format&fit=crop&q=60'
  },
  deadline: '2024-08-01',
  status: 'planning',
  budget: 6000
}, {
  id: '6',
  name: 'Red Bull Athlete Series',
  brand: {
    name: 'Red Bull'
  },
  creator: {
    name: 'David Brown',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&auto=format&fit=crop&q=60'
  },
  deadline: '2024-05-30',
  status: 'completed',
  budget: 7500
}];
export function ProjectsPage() {
  const navigate = useNavigate();
  const [view, setView] = useState<'grid' | 'list'>('grid');
  const [filter, setFilter] = useState<'all' | 'active' | 'planning' | 'completed'>('all');
  const filteredProjects = projects.filter(project => filter === 'all' || project.status === filter);
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-1335">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-1336">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-1337">
          <div className="flex items-center" data-id="element-1338">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/manager')} data-id="element-1339">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-1340" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-1341">
              Projects Overview
            </h1>
          </div>
          <Button variant="primary" size="sm" className="bg-blue-600 hover:bg-blue-700" data-id="element-1342">
            <Plus className="h-4 w-4 mr-2" data-id="element-1343" /> Create Project
          </Button>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1344">
          <div className="flex space-x-8 -mb-px" data-id="element-1345">
            <button onClick={() => navigate('/manager')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1346">
              Overview
            </button>
            <button onClick={() => navigate('/manager/brands')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1347">
              Brands
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-1348">
              Projects
            </button>
            <button onClick={() => navigate('/manager/platforms')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1349">
              Platforms
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1350">
        <div className="flex items-center justify-between mb-6" data-id="element-1351">
          <div className="flex items-center space-x-2" data-id="element-1352">
            <Button variant={filter === 'all' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('all')} data-id="element-1353">
              All
            </Button>
            <Button variant={filter === 'active' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('active')} data-id="element-1354">
              Active
            </Button>
            <Button variant={filter === 'planning' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('planning')} data-id="element-1355">
              Planning
            </Button>
            <Button variant={filter === 'completed' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('completed')} data-id="element-1356">
              Completed
            </Button>
          </div>
          <div className="flex items-center space-x-2" data-id="element-1357">
            <Button variant="ghost" size="sm" onClick={() => setView('grid')} className={view === 'grid' ? 'bg-gray-100' : ''} data-id="element-1358">
              <LayoutGrid className="h-4 w-4" data-id="element-1359" />
            </Button>
            <Button variant="ghost" size="sm" onClick={() => setView('list')} className={view === 'list' ? 'bg-gray-100' : ''} data-id="element-1360">
              <List className="h-4 w-4" data-id="element-1361" />
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1362">
          {filteredProjects.map(project => <ProjectCard key={project.id} project={project} data-id="element-1363" />)}
        </div>
      </main>
    </div>;
}